import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { LinkCardRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { LinkCardResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const linkCard = (request: LinkCardRequest, options?: CashRequestOptions) =>
  post<LinkCardRequest, LinkCardResponse>('/2.0/cash/link-card', request, { ...options, rejectOnError: true })
